import { NameDto } from 'api/Common/Types'
import { PermissionsEnum } from 'api/Identity/Types/PermissionsEnum'
import { links } from 'utils/featureToggles'
import { isString } from 'utils/is-string'

export enum TicketsViewType {
  Payments = 1,
  BackOffice = 2,
  Sales = 3,
  Compliance = 4,
  Translation = 5,
  Brokerage = 6,
  MyTickets = 100,
  All = 999,
}

export const isMyTicketView = (viewType: number | string): boolean => {
  return viewType === TicketsViewType.MyTickets
}

export const isSalesTicketView = (viewType: number): boolean => {
  return viewType === TicketsViewType.Sales
}

export const getTicketsViewType = (
  ticketsViewType: TicketsViewType | number | string
): TicketsViewType | undefined => {
  const viewType = isString(ticketsViewType)
    ? Number.parseInt(ticketsViewType, 10)
    : ticketsViewType
  switch (viewType) {
    case TicketsViewType.Payments:
      return TicketsViewType.Payments
    case TicketsViewType.BackOffice:
      return TicketsViewType.BackOffice
    case TicketsViewType.Sales:
      return TicketsViewType.Sales
    case TicketsViewType.Compliance:
      return TicketsViewType.Compliance
    case TicketsViewType.Translation:
      return TicketsViewType.Translation
    case TicketsViewType.MyTickets:
      return TicketsViewType.MyTickets
    case TicketsViewType.All:
      return TicketsViewType.All
    case TicketsViewType.Brokerage:
      return TicketsViewType.Brokerage
  }
}

export const isSalesTicket = (value: TicketsViewType): boolean => {
  return value === TicketsViewType.Sales
}

interface TicketViewTypeWithLabelAndPermission extends NameDto<TicketsViewType> {
  permission?: PermissionsEnum
}

export const getTicketViewTypeWithLabelAndPermission =
  (): TicketViewTypeWithLabelAndPermission[] => {
    return [
      {
        id: TicketsViewType.BackOffice,
        name: 'BackOffice',
        permission: PermissionsEnum.CanBrowseBackofficeTickets,
      },
      {
        id: TicketsViewType.Payments,
        name: 'Payments',
        permission: PermissionsEnum.CanBrowsePaymentsTickets,
      },
      {
        id: TicketsViewType.Compliance,
        name: 'Compliance',
        permission: PermissionsEnum.CanBrowseComplianceTickets,
      },
      {
        id: TicketsViewType.Translation,
        name: 'Translation',
        permission: PermissionsEnum.CanBrowseTranslationsTickets,
      },
      {
        id: TicketsViewType.Brokerage,
        name: 'Brokerage',
        permission: PermissionsEnum.CanBrowseBrokerageTickets,
      },
      {
        id: TicketsViewType.All,
        name: 'All',
      },
    ]
  }

export function generateTicketRouteByViewType(ticketTypeId: TicketsViewType): string {
  switch (ticketTypeId) {
    case TicketsViewType.Payments:
      return links.ticketsPayments.url
    case TicketsViewType.BackOffice:
      return links.ticketsBackoffice.url
    case TicketsViewType.Compliance:
      return links.ticketsCompliance.url
    case TicketsViewType.Sales:
      return links.ticketsSales.url
    case TicketsViewType.Translation:
      return links.ticketsTranslation.url
    case TicketsViewType.MyTickets:
      return links.ticketsMyTickets.url
    case TicketsViewType.Brokerage:
      return links.ticketsBrokerage.url
    default:
      return links.tickets.url
  }
}
